import clsx from "clsx";
import FormLogin from "ui/form-login";

export default function Page() {
  const isAplusguard = window.location.hostname.includes(
    "command.aplusguard.com",
  );
  return (
    <main
      className="flex flex-col items-center justify-center h-screen bg-slate-50 bg-cover bg-center min-h-[750px]"
      style={
        isAplusguard
          ? {
              backgroundImage: "url(/auth/background-login.png)",
              transform: "scaleX(-1)",
            }
          : {
              backgroundImage: "url(/auth/background-login.png)",
            }
      }
    >
      <div
        className={clsx(
          "flex flex-col items-center justify-center",
          isAplusguard && "transform scale-x-[-1]",
        )}
      >
        {isAplusguard ? (
          <h1 className="text-xl md:text-4xl leading-snug font-bold text-center md:mb-12 min-w-[400px] ml-2 mr-2">
            Detect Deter Protect
          </h1>
        ) : (
          <h1 className="text-xl md:text-4xl leading-snug font-bold text-center mb-4 md:mb-12 ml-2 mr-2">
            Our Mission is to protect people and property with
            <br />
            Simple Smart Scalable Solution
          </h1>
        )}
        <div className="max-w-[300px] md:max-w-[400px] z-10">
          <FormLogin isAplusguard={isAplusguard} />
        </div>
        <div
          className=""
          style={{
            marginTop: "24px",
            // transform: isAplusguard ? "scaleX(-1)" : "",
          }}
        >
          <div className="flex flex-col md:flex-row md:gap-2 items-center justify-center text-sm ">
            <span>© Copyright 2024 Alpha Vision.</span>
            <span>All rights reserved</span>
            <span className="flex gap-2">
              <a
                href="/tou.html"
                style={{
                  fontWeight: "600",

                  cursor: "pointer",
                }}
              >
                Terms of Service
              </a>
              <a
                href={
                  isAplusguard
                    ? "/privacy-policy-apg.html"
                    : "/privacy-policy.html"
                }
                style={{
                  fontWeight: "600",

                  cursor: "pointer",
                }}
              >
                Privacy Policy
              </a>
            </span>
          </div>
        </div>
      </div>
    </main>
  );
}
